import { defineComponent as _defineComponent } from 'vue'
import * as _ from 'lodash'
import { ref, computed } from 'vue'
import { useQueryLoading } from '@vue/apollo-composable'
import { useListTaxonomiesQuery, type TaxonomyType, useUpsertTaxonomyMutation, useDeleteTaxonomyMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Taxonomy',
  props: {
  value: {
    type: Array as () => number[],
    default: () => [],
  },
  modelValue: {
    type: Array as () => number[],
    default: undefined,
  },
  columns: {
    type: Array<string>,
    default: () => ['label'],
  },
  defaultFilters: {
    type: Object,
    default: () => {},
  },
  showSearch: {
    type: Boolean,
    default: false,
    required: false,
  },
  height: {
    type: String,
    default: 'calc(100vh - 200px)',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  singleSelect: {
    type: Boolean,
    default: false,
  }
},
  emits: ['input', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const currentIds = computed(
  () =>
    (props.modelValue !== undefined ? props.modelValue : props.value) || [],
)

const headers = computed(
  () =>
    [
      { value: 'id' },
      { value: 'label' },
      { value: 'shortLabel' },
      { value: 'actions' },
    ].filter((o) => props.columns?.includes(o.value)) || [],
)

const options = ref({ page: 1, itemsPerPage: -1, sortDesc: [true] })
const filters = ref({})
const variables = computed(() => ({
  input: { ...props.defaultFilters, ...filters.value },
  offset: options.value.itemsPerPage * (options.value.page - 1),
  limit: options.value.itemsPerPage,
}))

const { result, refetch } = useListTaxonomiesQuery(variables)

const items = computed<TaxonomyType[]>(
  () => result.value?.listTaxonomies ?? []
)

const selected = computed<number[]>(
  () =>
    items.value
      .filter((t: TaxonomyType) =>
        (currentIds.value || []).filter(Boolean).includes(t.id as any),
      )
      .map((t) => t.id),
)

// const search = ref('')
const onInput = (val: number[]) => {
  if (_.isEqual(val, currentIds.value)) {
    return
  }
  emit('update:modelValue', val)
  emit(
    'input',
    val,
  )
}

const loading = useQueryLoading()
const itemCount = computed(() => result?.value?.countTaxonomies || 0)

const {mutate: upsert, loading: upsertLoading} = useUpsertTaxonomyMutation()
const {mutate: deleteTaxonomy, loading: deleteLoading} = useDeleteTaxonomyMutation()

// Dialog state
const createDialog = ref(false)
const deleteDialog = ref(false)
const newTaxonomy = ref({
  label: '',
  shortLabel: '',
  description: ''
})
const taxonomyToDelete = ref<TaxonomyType | null>(null)

const openCreateDialog = () => {
  newTaxonomy.value = { label: '', shortLabel: '', description: '' }
  createDialog.value = true
}

const closeCreateDialog = () => {
  createDialog.value = false
  newTaxonomy.value = { label: '', shortLabel: '', description: '' }
}

const saveTaxonomy = async () => {
  if (!newTaxonomy.value.label || !newTaxonomy.value.shortLabel) {
    return
  }

  try {
    await upsert({
      input: {
        label: newTaxonomy.value.label,
        shortLabel: newTaxonomy.value.shortLabel,
        description: newTaxonomy.value.description
      }
    })
    closeCreateDialog()
    refetch()
  } catch (error) {
    console.error('Error creating taxonomy:', error)
  }
}

const openDeleteDialog = (taxonomy: TaxonomyType) => {
  taxonomyToDelete.value = taxonomy
  deleteDialog.value = true
}

const closeDeleteDialog = () => {
  deleteDialog.value = false
  taxonomyToDelete.value = null
}

const confirmDelete = async () => {
  if (!taxonomyToDelete.value) {
    return
  }

  try {
    console.log('taxonomyToDelete.value', taxonomyToDelete.value)
    await deleteTaxonomy({id: taxonomyToDelete.value.id})
    closeDeleteDialog()
    refetch()
  } catch (error) {
    console.error('Error deleting taxonomy:', error)
  }
}


return { __sfc: true,props, emit, currentIds, headers, options, filters, variables, result, refetch, items, selected, onInput, loading, itemCount, upsert, upsertLoading, deleteTaxonomy, deleteLoading, createDialog, deleteDialog, newTaxonomy, taxonomyToDelete, openCreateDialog, closeCreateDialog, saveTaxonomy, openDeleteDialog, closeDeleteDialog, confirmDelete }
}

})